import React, { useState, useEffect } from 'react'
import { Container } from '@material-ui/core'
import styles from './header_.module.css'
import strings from '../../strings/strings.json'
import { useRouter } from 'next/router'
import HeaderMobile from './header_mobile'
import Api from '../../../pages/api/api'
import { useDispatch } from 'react-redux'
import * as generalAction from '../../redux/action/general_action'
import BtnLogout from './btn_logout';
import BtnLogin from './btn_login';
export default function NewHeader(props) {

    const router = useRouter(),
        pathname = router.pathname
    const dispatch = useDispatch()
    const [user, setUser] = useState("guest")
    useEffect(() => {

        const userInfo = Api.getInfo()
        if (userInfo !== undefined &&
            userInfo &&
            userInfo.first_name !== user) {
            setUser(userInfo)
            dispatch(generalAction.setUserInfo(userInfo))
        }
    }, [props.isGuest])

    const logoutHandler = () => {
        localStorage.clear()
        window.location.href = '/';
    }

    const hoverHandler = (route) => {
        if (route === pathname.replace("/", ""))
            return styles.menu_style_selected
    }

    const logoHandler = () => {
        return <img className={styles.img} onClick={()=>router.push('/')} src={`/assets/icons/${pathname === "/" ? 'main_logo' : "logo_main_other"}.svg`} alt="Icon" />
    }

    return (
        <div className={styles.container}>
            <Container>
                <div className={`${styles.child_container}`}>
                    <div className={styles.img_container}>{logoHandler()}</div>
                    <div className={styles.menu}>
                        <span className={`${styles.menu_style} ${pathname === "/" ? styles.menu_style_home : styles.menu_style_other}`} onClick={() => router.push('/')}><img className={styles.home_icon} src={`/assets/icons/${pathname==='/'?'home-fill':'home-fill-blue'}.svg`} alt="Icon" /></span>
                        <span className={`${styles.menu_style} ${pathname === "/" ? styles.menu_style_home : `${styles.menu_style_other} ${hoverHandler('search')} ${hoverHandler('search/[packagename]')}`}`} onClick={() => router.push('/search')}>{strings.general_search}</span>
                        <span className={`${styles.menu_style} ${pathname === "/" ? styles.menu_style_home : `${styles.menu_style_other} ${hoverHandler('aboutApp')}`}`} onClick={() => router.push('/aboutApp')}>{strings.footer_aboutSystem}</span>
                        <span className={`${styles.menu_style} ${pathname === "/" ? styles.menu_style_home : `${styles.menu_style_other} ${hoverHandler('plans')}`}`} onClick={() => router.push('/plans')}>{strings.general_plans}</span>
                        <span className={`${styles.menu_style} ${pathname === "/" ? styles.menu_style_home : styles.menu_style_other}`} onClick={() => window.open('https://docs.cyberno.ir/fa/blog/faq')}>{strings.general_faq}</span>
                    </div>
                    <div className={styles.btn_container}>
                        {
                            user.first_name === undefined || user.first_name === "guest" ?
                                <BtnLogin onClickHandler={() => router.push('/login')} />
                                :
                                <BtnLogout user={user} logoutHandler={logoutHandler} />
                        }
                    </div>
                </div>
                <div className={styles.mobile_mode}><HeaderMobile logo={logoHandler()} /></div>
            </Container>
        </div>
    )
}


